import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
const steps = [
    { id: 'topic', label: '选题', path: '/topics', icon: '📋' },
    { id: 'script', label: '剧本', path: '/script', icon: '✍️' },
    { id: 'casting', label: '选角', path: '/casting', icon: '👥' },
    { id: 'storyboard', label: '分镜', path: '/storyboard', icon: '🎬' },
    { id: 'video', label: '视频', path: '/editor', icon: '🎞️' },
    { id: 'publish', label: '发布', path: '/publish', icon: '🚀' }
];
export function WorkflowSteps({ projectId, currentStep }) {
    const navigate = useNavigate();
    const currentIndex = steps.findIndex(s => s.id === currentStep);
    const handleStepClick = (step, index) => {
        // 只允许跳转到当前步骤或之前的步骤
        if (index <= currentIndex) {
            const path = step.path.replace(':id', projectId);
            navigate(`/project/${projectId}${path}`);
        }
    };
    return (_jsx("div", { className: "flex items-center justify-center gap-2 py-4", children: steps.map((step, index) => {
            const isActive = step.id === currentStep;
            const isCompleted = index < currentIndex;
            const isAccessible = index <= currentIndex;
            return (_jsxs("div", { className: "flex items-center", children: [_jsxs("button", { onClick: () => handleStepClick(step, index), disabled: !isAccessible, className: `flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-all ${isActive
                            ? 'bg-primary-600 text-white shadow-lg'
                            : isCompleted
                                ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer'
                                : isAccessible
                                    ? 'bg-gray-700 text-gray-300 hover:bg-gray-600 cursor-pointer'
                                    : 'bg-gray-800 text-gray-500 cursor-not-allowed'}`, children: [_jsx("span", { className: "text-lg", children: step.icon }), _jsx("span", { children: step.label }), isCompleted && _jsx("span", { className: "text-xs", children: "\u2713" })] }), index < steps.length - 1 && (_jsx("div", { className: `mx-2 h-0.5 w-8 ${index < currentIndex ? 'bg-green-600' : 'bg-gray-700'}` }))] }, step.id));
        }) }));
}
